import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../dataContext";
import { ROUTE_CONSTANTS } from "../constants/routeConstants";

const { PAYMENT_REQUEST_DETAIL } = ROUTE_CONSTANTS;

const PaymentRequests = () => {
  const navigate = useNavigate();
  const { paymentRequests, getPaymentRequests, locallyHandledRequestIds } =
    useContext(DataContext);

  useEffect(() => {
    getPaymentRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Backend already filters to pending incoming RfPs; we only need to drop
  // anything the user optimistically declined locally.
  const visible = (paymentRequests || []).filter(
    (t) => !(locallyHandledRequestIds || []).includes(t.id)
  );

  const arrowDown = (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="12" y1="4" x2="12" y2="18" />
      <polyline points="6 12 12 18 18 12" />
    </svg>
  );

  return (
    <main className="page_with_nav" style={{ justifyContent: "flex-start" }}>
      {visible.length === 0 ? (
        <div className="center_page_with_nav">
          <h2>You're all caught up</h2>
          <p className="np-muted" style={{ margin: "8px 0 0", fontSize: "16px" }}>
            No pending payment requests.
          </p>
        </div>
      ) : (
        <>
          <div
            className="np-group-header"
            style={{ textAlign: "right", margin: "0 4px 8px 0" }}
          >
            {visible.length} pending
          </div>
          <ul className="np-card">
            {visible.map((request) => (
              <li
                key={request.id}
                className="np-list-row np-list-row-top"
                onClick={() =>
                  navigate(PAYMENT_REQUEST_DETAIL.replace(":id", request.id))
                }
                data-cy="pending_payment_request_row"
              >
                <span className="np-avatar np-avatar-accent">{arrowDown}</span>
                <div className="np-list-body">
                  <div className="np-list-title">
                    {request.sender_name || "Someone"} is requesting
                  </div>
                  <div className="np-list-sub">Awaiting your payment</div>
                  {request.note && (
                    <div className="np-list-note">"{request.note}"</div>
                  )}
                </div>
                <div className="np-list-amount">
                  ${parseFloat(request.amount?.value).toFixed(2)}
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </main>
  );
};

export default PaymentRequests;
